import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Person} from '../../person'
@Component({
  selector: 'app-person-row',
  templateUrl: './person-row.component.html',
  styleUrls: ['./person-row.component.scss']
})



export class PersonRowComponent implements OnInit {

  constructor() { }

  @Input() public person:Person
  @Output() public personChange: EventEmitter<Person> = new EventEmitter<Person>()

  private _person:Person
  ngOnInit() {
    if(this.person){
      this._person = this.person;
    }else{
      this._person = new Person();
    }
  }

  fireChange(){
    this.personChange.emit(this._person);
  }
}

